import type { FeedbackMessages } from './en';

const ar: FeedbackMessages = {
  qualified: {
    title: 'شكرًا لك على إتمام هذه الدراسة!',
    body1: 'يمكنك الآن إغلاق نافذة المتصفح.',
    body2: 'نأمل أن نراك مجددًا قريبًا.',
    refCode: 'الرمز المرجعي: {code}',
  },
  quotaFull: {
    title: 'هذه الدراسة مغلقة',
    body1: 'شكرًا لاهتمامك بدراستنا.',
    body2: 'للأسف، لقد تلقينا بالفعل جميع الردود التي نحتاج إليها.',
    body3: 'نأمل أن نراك في أحد دراساتنا المستقبلية!',
    refCode: 'الرمز المرجعي: {code}',
  },
  terminated: {
    title: 'شكرًا لك على مشاركة ملاحظاتك!',
    body1:
      'نأمل أن نراك قريبًا في دراساتنا المستقبلية. إلى ذلك الحين، نتمنى لك يومًا سعيدًا.',
    body2: 'يرجى إغلاق نافذة المتصفح هذه.',
    refCode: 'الرمز المرجعي: {code}',
  },
  mismatch: {
    title: 'شكرًا لاهتمامك',
    body1: 'للأسف، أنت لا تنتمي إلى الفئة المستهدفة لهذه الدراسة بالتحديد.',
    body2: 'يمكنك إغلاق هذه الصفحة.',
    code: 'الرمز: {code}',
  },
  error: {
    title: 'لا يمكننا تلبية طلبك',
    linkProblemDetailed:
      'يواجه الرابط الذي اتبعته مشكلة. يرجى التحقق من أن الرابط الموجود في شريط العنوان يطابق الرابط الذي تم تزويدك به، ثم أعد المحاولة.',
    linkProblemGeneric:
      'يواجه الرابط الذي اتبعته مشكلة. يرجى المحاولة مرة أخرى.',
    contactPerson:
      'إذا استمرت المشكلة، يرجى إخبار الشخص الذي حصلت منه على الرابط بهذه المشكلة.',
    errorCode: 'رمز الخطأ: {code}',
  },
};

export default ar;
